import React, { useCallback } from 'react';

export const PartGroup = ({
    partGroup, chosenPartGroup, setChosenPartGroup, getPartPartGroupUrl,


}) => {
    const handleSubCategoryClick = useCallback(() => {
        setChosenPartGroup(chosenPartGroup === partGroup.Name ? '' : partGroup.Name);
    }, [chosenPartGroup, partGroup.Name, setChosenPartGroup]);

    return (
        <React.Fragment
            key={partGroup.Name}
        >
            {chosenPartGroup === partGroup.Name ?
                (<li onClick={handleSubCategoryClick}>
                    <div className="chosenPartGroupClicked">
                        <p>
                            <span className="linkCaret">‹ </span>
                            {partGroup.Name}
                        </p>
                    </div>
                </li>) :
                (<li
                    onClick={handleSubCategoryClick}
                    className="partsGroupListItemL1"
                >
                    <p>
                        {partGroup.Name}
                        <span className="linkCaret"> ›</span>
                    </p>
                </li>
                )}

            {chosenPartGroup === partGroup.Name && (
                <ul>
                    {partGroup.Parts.sort((a, b) => a.Name.localeCompare(b.Name)).map((part) => (
                        <li data-img className="partsGroupListItemL2" key={part.Name}>
                            {/* <a href={getPartPartGroupUrl(part.Name, partGroup.Name)}>
                                {part.Name}
                                <span className="linkCaret"> ›</span>
                            </a> */}

                            <a className='partListUnFilteredItem' href={part.Url}>
                                {part.Name}
                                <span className="linkCaret"> ›</span>
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </React.Fragment>
    );
};
